import PropTypes from 'prop-types';
import React from 'react';
import i18n from '../../i18n/i18n';
import './MissingContactEmailWarning.scss';

const MissingContactEmailWarning = ({ onConfigure, variant }) => (
  <div className="MissingContactEmailWarning" role="alert">
    <i className="MissingContactEmailWarning__Icon fa fa-exclamation-triangle" aria-hidden />
    <div className="MissingContactEmailWarning__Body">
      <p className="MissingContactEmailWarning__Title">
        {i18n.t(`generic.errors.contact-email-${variant}-title`)}
      </p>
      <p className="MissingContactEmailWarning__Text">
        {i18n.t(`generic.errors.contact-email-${variant}-hint`)}
      </p>
    </div>
    {onConfigure && (
      <button
        type="button"
        className="MissingContactEmailWarning__Button button is-warning"
        onClick={onConfigure}
      >
        <i className="fa fa-cog" style={{ marginRight: '0.5em' }} aria-hidden />
        {i18n.t('generic.actions.configure')}
      </button>
    )}
  </div>
);

MissingContactEmailWarning.propTypes = {
  onConfigure: PropTypes.func,
  variant: PropTypes.oneOf(['missing', 'invalid']),
};

MissingContactEmailWarning.defaultProps = {
  onConfigure: undefined,
  variant: 'missing',
};

export default MissingContactEmailWarning;
